export default __webpack_public_path__ + "static/12_37-e6895baf7133ae186cf2d9acc5e7100e.png";